// extracted by mini-css-extract-plugin
var _1 = "mMWJi";
export { _1 as "buttons" }
